export default __webpack_public_path__ + "static/BillShawver-b25fdcd02c3b553d140de5f89da42d21.jpg";